import React from 'react';

import { Image, ImageProps } from 'src/components/Image/Image';
import { FlatSysV2 } from 'src/services/cms/typesUtil';

export type ContentImageEntry = FlatSysV2 & Partial<{
  title: string;
  file: {
    url: string;
    details?: {
      image?: {
        width: number;
        height: number;
      };
    };
  };
}>;

export interface ContentImageProps extends Omit<ImageProps, 'src' | 'dataAssetId'>{
  entry?: ContentImageEntry;
}

export const ContentImage = React.forwardRef<HTMLImageElement, ContentImageProps>(({ entry, alt, ...props }, ref) => {
  if (!entry) return null;
  const { file: { url } = {}, id } = entry;
  if (!url) return null;

  return (
    <Image
      src={url}
      alt={alt !== undefined ? alt : entry.title}
      dataAssetId={id}
      ref={ref}
      {...props}
    />
  );
});

ContentImage.displayName = 'ContentImage';
